import { getHelpDownloadByRole } from '../../content/help/helpDownloads';
import type { WalkthroughRole } from '../../content/help/walkthroughTypes';

export const getRoleHelpBasePath = (role: WalkthroughRole): string =>
  role === 'homeowner' ? '/dashboard/help' : '/contractor/help';

export const buildRoleHelpLink = (role: WalkthroughRole, sectionId?: string): string => {
  const base = getRoleHelpBasePath(role);
  return sectionId ? `${base}#${sectionId}` : base;
};

export const getRoleDownloadLink = (role: WalkthroughRole): string | null => {
  const cfg = getHelpDownloadByRole(role);
  if (!cfg || cfg.status !== 'live') return null;
  return cfg.pdfUrl || cfg.pptxUrl || null;
};

